import { render } from "./TransferOrderDetail.vue?vue&type=template&id=09e4e7a7&scoped=true&ts=true"
import script from "./TransferOrderDetail.vue?vue&type=script&lang=ts"
export * from "./TransferOrderDetail.vue?vue&type=script&lang=ts"

import "./TransferOrderDetail.vue?vue&type=style&index=0&id=09e4e7a7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09e4e7a7"]])

export default __exports__